import { createBaseQuery } from "@/redux/config";
import { createApi } from "@reduxjs/toolkit/query/react";

export const productLogApi = createApi({
  reducerPath: "productLogApi",
  baseQuery: createBaseQuery("/c/"),
  tagTypes: [
    "ProductLog",
    "ProductLogSummary",
    "ProductInfo",
    "ProductLogData",
  ],
  endpoints: (build) => ({
    listProductLogs: build.query<
      ProductLog[],
      { companyId: number; serviceId: number; filter: ProductLogSummaryFilter }
    >({
      query: ({ companyId, serviceId, filter }) => ({
        url: `${companyId}/services/${serviceId}/product-logs`,
        method: "POST",
        body: filter,
      }),
      providesTags: ["ProductLog"],
    }),
    buildProductLogSummary: build.query<
      ProductLogSummary[],
      { companyId: number; serviceId: number; filter: ProductLogSummaryFilter }
    >({
      query: ({ companyId, serviceId, filter }) => ({
        url: `${companyId}/services/${serviceId}/product-logs/summary`,
        method: "POST",
        body: filter,
      }),
      providesTags: ["ProductLogSummary"],
    }),
    buildProductInfo: build.query<
      ProductInfo,
      { companyId: number; serviceId: number; filter: ProductLogSummaryFilter }
    >({
      query: ({ companyId, serviceId, filter }) => ({
        url: `${companyId}/services/${serviceId}/product-logs/info`,
        method: "POST",
        body: filter,
      }),
      providesTags: ["ProductInfo"],
    }),
    listProductLogDataReport: build.query<
      ProductLogTxReporting[],
      { companyId: number; serviceId: number; filter: ProductLogSummaryFilter }
    >({
      query: ({ companyId, serviceId, filter }) => ({
        url: `${companyId}/services/${serviceId}/product-logs/reporting`,
        method: "POST",
        body: filter,
      }),
      providesTags: ["ProductInfo"],
    }),
    listProductLogData: build.query<
      ProductLogData[],
      {
        companyId: number;
        serviceId: number;
        categoryId: number;
        productLogId: number;
      }
    >({
      query: ({ companyId, serviceId, categoryId, productLogId }) => ({
        url: `${companyId}/services/${serviceId}/product-logs/data/${categoryId}/${productLogId}`,
        method: "POST",
      }),
      providesTags: ["ProductLogData"],
    }),
  }),
});
